module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Ждем вас на собеседовании"}}')
  delete Component.options._Ctor
}
